import styled, { css } from 'styled-components';

import { media } from '../../styles/constants';

const EmphasisCircle = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  > div {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 18rem;

    @media (min-width: ${media.phone}) {
      height: 22.5rem;
    }

    @media (min-width: ${media.tabletPortrait}) {
      position: static;
      height: 36rem;
    }

    @media (min-width: ${media.tabletLandscape}) {
      height: 40rem;
    }

    @media (min-width: ${media.desktop}) {
      height: 48rem;
    }
  }

  p {
    width: 100%;

    @media (min-width: ${media.tabletLandscape}) {
      width: 80%;
    }
  }

  .big {
    font-size: 5.1rem;
    padding-bottom: 1rem;
    position: relative;

    @media (min-width: ${media.tabletPortrait}) {
      font-size: 8.4rem;
      padding-bottom: 1rem;
    }

    @media (min-width: ${media.tabletLandscape}) {
      font-size: 10rem;
      padding-bottom: 0;
    }

    ${props =>
      props.lastLetter &&
      css`
        margin-left: -1.5rem;

        @media (min-width: ${media.tabletPortrait}) {
          margin-left: -2.5rem;
        }

        @media (min-width: ${media.tabletLandscape}) {
          margin-left: -3.5rem;
        }

        &::after {
          content: "${props.lastLetter}";
          position: absolute;

          @media (min-width: ${media.tabletPortrait}) {
            font-size: 5.8rem;
            top: -1.5rem;
            padding-left: 0.2rem;
          }

          @media (min-width: ${media.tabletLandscape}) {
            font-size: 6.8rem;
            top: -2rem;
            padding-left: 0.3rem;
          }
        }
      `}
  }

  .small {
    font-size: 2.2rem;
    line-height: 3rem;
    padding-bottom: 0;

    @media (min-width: ${media.tabletPortrait}) {
      padding-top: 1.8rem;
      font-size: 3rem;
      line-height: 3.9rem;
    }

    @media (min-width: ${media.tabletLandscape}) {
      padding-top: 3.8rem;
      font-size: 3.4rem;
      line-height: 4.5rem;
    }
  }
`;

export default EmphasisCircle;
